/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as R404RouteImport } from './routes/404'
import { Route as MonitorRouteRouteImport } from './routes/monitor/route'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as ArcRouteRouteImport } from './routes/arc/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ArcIndexRouteImport } from './routes/arc/index'
import { Route as AuthSuccessRouteRouteImport } from './routes/auth/success/route'
import { Route as AuthSignInRouteRouteImport } from './routes/auth/sign-in/route'
import { Route as ArcStatusRouteRouteImport } from './routes/arc/status/route'
import { Route as ArcStatisticsRouteRouteImport } from './routes/arc/statistics/route'
import { Route as ArcProfileRouteRouteImport } from './routes/arc/profile/route'
import { Route as AuthCallbackMicrosoftRouteImport } from './routes/auth/callback/microsoft'
import { Route as AuthWardenResetPasswordRouteRouteImport } from './routes/auth/warden/reset-password/route'
import { Route as AuthWardenRegisterRouteRouteImport } from './routes/auth/warden/register/route'
import { Route as ArcStatusOfflineRouteRouteImport } from './routes/arc/status/offline/route'
import { Route as ArcStatusAvailableRouteRouteImport } from './routes/arc/status/available/route'
import { Route as ArcStatusAdminRouteRouteImport } from './routes/arc/status/admin/route'

const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const MonitorRouteRoute = MonitorRouteRouteImport.update({
  id: '/monitor',
  path: '/monitor',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ArcRouteRoute = ArcRouteRouteImport.update({
  id: '/arc',
  path: '/arc',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArcIndexRoute = ArcIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ArcRouteRoute,
} as any)
const AuthSuccessRouteRoute = AuthSuccessRouteRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignInRouteRoute = AuthSignInRouteRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRouteRoute,
} as any)
const ArcStatusRouteRoute = ArcStatusRouteRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => ArcRouteRoute,
} as any)
const ArcStatisticsRouteRoute = ArcStatisticsRouteRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => ArcRouteRoute,
} as any)
const ArcProfileRouteRoute = ArcProfileRouteRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ArcRouteRoute,
} as any)
const AuthCallbackMicrosoftRoute = AuthCallbackMicrosoftRouteImport.update({
  id: '/callback/microsoft',
  path: '/callback/microsoft',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthWardenResetPasswordRouteRoute =
  AuthWardenResetPasswordRouteRouteImport.update({
    id: '/warden/reset-password',
    path: '/warden/reset-password',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthWardenRegisterRouteRoute = AuthWardenRegisterRouteRouteImport.update({
  id: '/warden/register',
  path: '/warden/register',
  getParentRoute: () => AuthRouteRoute,
} as any)
const ArcStatusOfflineRouteRoute = ArcStatusOfflineRouteRouteImport.update({
  id: '/offline',
  path: '/offline',
  getParentRoute: () => ArcStatusRouteRoute,
} as any)
const ArcStatusAvailableRouteRoute = ArcStatusAvailableRouteRouteImport.update({
  id: '/available',
  path: '/available',
  getParentRoute: () => ArcStatusRouteRoute,
} as any)
const ArcStatusAdminRouteRoute = ArcStatusAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => ArcStatusRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/arc': typeof ArcRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRoute
  '/monitor': typeof MonitorRouteRoute
  '/404': typeof R404Route
  '/arc/profile': typeof ArcProfileRouteRoute
  '/arc/statistics': typeof ArcStatisticsRouteRoute
  '/arc/status': typeof ArcStatusRouteRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRouteRoute
  '/auth/success': typeof AuthSuccessRouteRoute
  '/arc/': typeof ArcIndexRoute
  '/arc/status/admin': typeof ArcStatusAdminRouteRoute
  '/arc/status/available': typeof ArcStatusAvailableRouteRoute
  '/arc/status/offline': typeof ArcStatusOfflineRouteRoute
  '/auth/warden/register': typeof AuthWardenRegisterRouteRoute
  '/auth/warden/reset-password': typeof AuthWardenResetPasswordRouteRoute
  '/auth/callback/microsoft': typeof AuthCallbackMicrosoftRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRoute
  '/monitor': typeof MonitorRouteRoute
  '/404': typeof R404Route
  '/arc/profile': typeof ArcProfileRouteRoute
  '/arc/statistics': typeof ArcStatisticsRouteRoute
  '/arc/status': typeof ArcStatusRouteRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRouteRoute
  '/auth/success': typeof AuthSuccessRouteRoute
  '/arc': typeof ArcIndexRoute
  '/arc/status/admin': typeof ArcStatusAdminRouteRoute
  '/arc/status/available': typeof ArcStatusAvailableRouteRoute
  '/arc/status/offline': typeof ArcStatusOfflineRouteRoute
  '/auth/warden/register': typeof AuthWardenRegisterRouteRoute
  '/auth/warden/reset-password': typeof AuthWardenResetPasswordRouteRoute
  '/auth/callback/microsoft': typeof AuthCallbackMicrosoftRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/arc': typeof ArcRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRoute
  '/monitor': typeof MonitorRouteRoute
  '/404': typeof R404Route
  '/arc/profile': typeof ArcProfileRouteRoute
  '/arc/statistics': typeof ArcStatisticsRouteRoute
  '/arc/status': typeof ArcStatusRouteRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRouteRoute
  '/auth/success': typeof AuthSuccessRouteRoute
  '/arc/': typeof ArcIndexRoute
  '/arc/status/admin': typeof ArcStatusAdminRouteRoute
  '/arc/status/available': typeof ArcStatusAvailableRouteRoute
  '/arc/status/offline': typeof ArcStatusOfflineRouteRoute
  '/auth/warden/register': typeof AuthWardenRegisterRouteRoute
  '/auth/warden/reset-password': typeof AuthWardenResetPasswordRouteRoute
  '/auth/callback/microsoft': typeof AuthCallbackMicrosoftRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/arc'
    | '/auth'
    | '/dashboard'
    | '/monitor'
    | '/404'
    | '/arc/profile'
    | '/arc/statistics'
    | '/arc/status'
    | '/auth/sign-in'
    | '/auth/success'
    | '/arc/'
    | '/arc/status/admin'
    | '/arc/status/available'
    | '/arc/status/offline'
    | '/auth/warden/register'
    | '/auth/warden/reset-password'
    | '/auth/callback/microsoft'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/dashboard'
    | '/monitor'
    | '/404'
    | '/arc/profile'
    | '/arc/statistics'
    | '/arc/status'
    | '/auth/sign-in'
    | '/auth/success'
    | '/arc'
    | '/arc/status/admin'
    | '/arc/status/available'
    | '/arc/status/offline'
    | '/auth/warden/register'
    | '/auth/warden/reset-password'
    | '/auth/callback/microsoft'
  id:
    | '__root__'
    | '/'
    | '/arc'
    | '/auth'
    | '/dashboard'
    | '/monitor'
    | '/404'
    | '/arc/profile'
    | '/arc/statistics'
    | '/arc/status'
    | '/auth/sign-in'
    | '/auth/success'
    | '/arc/'
    | '/arc/status/admin'
    | '/arc/status/available'
    | '/arc/status/offline'
    | '/auth/warden/register'
    | '/auth/warden/reset-password'
    | '/auth/callback/microsoft'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ArcRouteRoute: typeof ArcRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  DashboardRouteRoute: typeof DashboardRouteRoute
  MonitorRouteRoute: typeof MonitorRouteRoute
  R404Route: typeof R404Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/monitor': {
      id: '/monitor'
      path: '/monitor'
      fullPath: '/monitor'
      preLoaderRoute: typeof MonitorRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arc': {
      id: '/arc'
      path: '/arc'
      fullPath: '/arc'
      preLoaderRoute: typeof ArcRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arc/': {
      id: '/arc/'
      path: '/'
      fullPath: '/arc/'
      preLoaderRoute: typeof ArcIndexRouteImport
      parentRoute: typeof ArcRouteRoute
    }
    '/auth/success': {
      id: '/auth/success'
      path: '/success'
      fullPath: '/auth/success'
      preLoaderRoute: typeof AuthSuccessRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/arc/status': {
      id: '/arc/status'
      path: '/status'
      fullPath: '/arc/status'
      preLoaderRoute: typeof ArcStatusRouteRouteImport
      parentRoute: typeof ArcRouteRoute
    }
    '/arc/statistics': {
      id: '/arc/statistics'
      path: '/statistics'
      fullPath: '/arc/statistics'
      preLoaderRoute: typeof ArcStatisticsRouteRouteImport
      parentRoute: typeof ArcRouteRoute
    }
    '/arc/profile': {
      id: '/arc/profile'
      path: '/profile'
      fullPath: '/arc/profile'
      preLoaderRoute: typeof ArcProfileRouteRouteImport
      parentRoute: typeof ArcRouteRoute
    }
    '/auth/callback/microsoft': {
      id: '/auth/callback/microsoft'
      path: '/callback/microsoft'
      fullPath: '/auth/callback/microsoft'
      preLoaderRoute: typeof AuthCallbackMicrosoftRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/warden/reset-password': {
      id: '/auth/warden/reset-password'
      path: '/warden/reset-password'
      fullPath: '/auth/warden/reset-password'
      preLoaderRoute: typeof AuthWardenResetPasswordRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/warden/register': {
      id: '/auth/warden/register'
      path: '/warden/register'
      fullPath: '/auth/warden/register'
      preLoaderRoute: typeof AuthWardenRegisterRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/arc/status/offline': {
      id: '/arc/status/offline'
      path: '/offline'
      fullPath: '/arc/status/offline'
      preLoaderRoute: typeof ArcStatusOfflineRouteRouteImport
      parentRoute: typeof ArcStatusRouteRoute
    }
    '/arc/status/available': {
      id: '/arc/status/available'
      path: '/available'
      fullPath: '/arc/status/available'
      preLoaderRoute: typeof ArcStatusAvailableRouteRouteImport
      parentRoute: typeof ArcStatusRouteRoute
    }
    '/arc/status/admin': {
      id: '/arc/status/admin'
      path: '/admin'
      fullPath: '/arc/status/admin'
      preLoaderRoute: typeof ArcStatusAdminRouteRouteImport
      parentRoute: typeof ArcStatusRouteRoute
    }
  }
}

interface ArcStatusRouteRouteChildren {
  ArcStatusAdminRouteRoute: typeof ArcStatusAdminRouteRoute
  ArcStatusAvailableRouteRoute: typeof ArcStatusAvailableRouteRoute
  ArcStatusOfflineRouteRoute: typeof ArcStatusOfflineRouteRoute
}

const ArcStatusRouteRouteChildren: ArcStatusRouteRouteChildren = {
  ArcStatusAdminRouteRoute: ArcStatusAdminRouteRoute,
  ArcStatusAvailableRouteRoute: ArcStatusAvailableRouteRoute,
  ArcStatusOfflineRouteRoute: ArcStatusOfflineRouteRoute,
}

const ArcStatusRouteRouteWithChildren = ArcStatusRouteRoute._addFileChildren(
  ArcStatusRouteRouteChildren,
)

interface ArcRouteRouteChildren {
  ArcProfileRouteRoute: typeof ArcProfileRouteRoute
  ArcStatisticsRouteRoute: typeof ArcStatisticsRouteRoute
  ArcStatusRouteRoute: typeof ArcStatusRouteRouteWithChildren
  ArcIndexRoute: typeof ArcIndexRoute
}

const ArcRouteRouteChildren: ArcRouteRouteChildren = {
  ArcProfileRouteRoute: ArcProfileRouteRoute,
  ArcStatisticsRouteRoute: ArcStatisticsRouteRoute,
  ArcStatusRouteRoute: ArcStatusRouteRouteWithChildren,
  ArcIndexRoute: ArcIndexRoute,
}

const ArcRouteRouteWithChildren = ArcRouteRoute._addFileChildren(
  ArcRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthSignInRouteRoute: typeof AuthSignInRouteRoute
  AuthSuccessRouteRoute: typeof AuthSuccessRouteRoute
  AuthWardenRegisterRouteRoute: typeof AuthWardenRegisterRouteRoute
  AuthWardenResetPasswordRouteRoute: typeof AuthWardenResetPasswordRouteRoute
  AuthCallbackMicrosoftRoute: typeof AuthCallbackMicrosoftRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthSignInRouteRoute: AuthSignInRouteRoute,
  AuthSuccessRouteRoute: AuthSuccessRouteRoute,
  AuthWardenRegisterRouteRoute: AuthWardenRegisterRouteRoute,
  AuthWardenResetPasswordRouteRoute: AuthWardenResetPasswordRouteRoute,
  AuthCallbackMicrosoftRoute: AuthCallbackMicrosoftRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArcRouteRoute: ArcRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  DashboardRouteRoute: DashboardRouteRoute,
  MonitorRouteRoute: MonitorRouteRoute,
  R404Route: R404Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
